import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { COLORS } from 'theme';
import { StyledButton, StyledDotsIcon } from './MenuButton.styles';

function MenuButton({ isActive, ...props }) {
  return (
    <StyledButton $isActive={isActive} {...props}>
      <StyledDotsIcon
        sx={{ color: isActive ? COLORS.kinetikBlack : COLORS.black40 }}
      />
    </StyledButton>
  );
}

MenuButton.propTypes = {
  isActive: PropTypes.bool,
};

export default memo(MenuButton);
